let { View, Utils } = window.App;
import $ from 'jquery';

if( typeof paysafe !== 'undefined' ){
    let apiKey = "T1QtMjU5NzIwOkItcWEyLTAtNWJlNDUyMmUtMC0zMDJjMDIxNDMyMzczNzU1NjhhZWEyZDdkMjMxMmQ2MzM3NmJiYTkxMWJiYjY4NTcwMjE0NWMzMGIxNTMwYzZiYTM0ZTU1NmY5NTRlMDBhMzcwZTNmNWRmN2MwMA==";

    let options = {
        environment: "TEST",

        locale: 'fr_CA',

        fields: {
            cardNumber: {
                selector   : "#card-number",
                placeholder: "Numéro de carte",
                separator  : " ",
            },
            expiryDate: {
                selector   : "#card-expiry-date",
                placeholder: "MM / YY",
            },
            cvv       : {
                selector   : "#card-cvv",
                placeholder: "CVV",
                optional   : false,
            },
        },
    };

    paysafe.fields.setup( apiKey, options, function( instance, error ){
        let $error_holder = $( '#paysafe-error-holder' );
        let $error = $( '#paysafe-error' );
        let $button = $( "#pay-now" );
        $button.on( "click", function( event ){
            $button.addClass( '__loading' );
            $error_holder.hide();
            instance.tokenize( function( instance, error, result ){
                if( error ){
                    let invalid_fields = []
                    if( !instance.fields.cardNumber.isValid() ) invalid_fields.push( 'card_number' );
                    if( !instance.fields.expiryDate.isValid() ) invalid_fields.push( 'expiry_date' );
                    if( !instance.fields.cvv.isValid() ) invalid_fields.push( 'cvv' );

                    $error_holder.show();
                    $error.html( 'Champs invalides: ' + invalid_fields.join( ', ' ) );
                    $button.removeClass( '__loading' );
                }else{
                    Utils.post( $button.data( 'url' ), { token: result.token } );
                }
            } );
        } );
    } );
}



// WEBPACK FOOTER //
// ./resources/assets/js/modules/paysafe-checkout.js